import { Layout } from '@eneco/flows/components';
import { createFlowProvider } from '@eneco/flows/utils';

import { actions, initialContext, routes } from './configs/smeEnergyFlow.config';
import { FlowContextSme } from './context';

const { Provider, Navigation, Router } = createFlowProvider<FlowContextSme>({
  routes: routes,
  actions,
  initialContext,
});

const SmeEnergyFlow = () => {
  return (
    <Provider>
      <Layout>
        <Layout.Header>
          <Navigation />
        </Layout.Header>

        <Router />
      </Layout>
    </Provider>
  );
};

export default SmeEnergyFlow;
